import React, { useState, useEffect, useRef } from "react";
import { Link  } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { showToast } from "../Common/Messages";


const Products = (props)=> {
    const LoginStates = useSelector(state => state.login);
    const [productList, setProductList] = useState([]);
    const trackRef = useRef(null);
    const animationFrameId = useRef(null);
    const isPaused = useRef(false);
    const speed = 0.5; // 움직이는 속도 (픽셀 단위)
    const [isOverflow, setIsOverflow] = useState(false);

    useEffect(() => {
        getProductList();
        const track = trackRef.current;

        return () => {
            cleanupAnimationAndListeners(track);
        };
    }, []);

    useEffect(() => {
        const track = trackRef.current;
        if (!track) return;
        const isOverflow = productList.length >= 4;
        setIsOverflow(isOverflow);
        if(isOverflow) {
            animationFrameId.current = requestAnimationFrame(animate);
            track.addEventListener("mouseenter", handleMouseEnter);
            track.addEventListener("mouseleave", handleMouseLeave);
        } else {
            cleanupAnimationAndListeners(track);
        }
    }, [productList]);

    const cleanupAnimationAndListeners = (track) => {
        cancelAnimationFrame(animationFrameId.current);
        track?.removeEventListener("mouseenter", handleMouseEnter);
        track?.removeEventListener("mouseleave", handleMouseLeave);
    };

    const animate = () => {
        if (!isPaused.current) {
            const track = trackRef.current;
            if (!track) return;
            const currentTransform = getComputedStyle(track).transform;
            const match = currentTransform.match(/matrix\((.*)\)/);
            const translateX = match ? parseFloat(match[1].split(", ")[4]) : 0;

            // 새로운 위치 계산
            const newPosition = translateX - speed;

            // 무한 스크롤: 트랙이 복제된 끝에 도달하면 원점으로 되돌림
            const resetPosition = Math.abs(newPosition) >= track.scrollWidth / 2 ? 0 : newPosition;
            track.style.transform = `translateX(${resetPosition}px)`;
        }

        animationFrameId.current = requestAnimationFrame(animate); // useRef로 저장
    };

    // hover 이벤트 처리
    const handleMouseEnter = () => isPaused.current = true;
    const handleMouseLeave = () => isPaused.current = false;

    const getProductList = async () => {
        const response = await fetch('datas/oper/products.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Cache-Control': 'no-cache'
            }
        });
        const result = await response.json();
        if (result && response.ok) {
            setProductList(result);
        }
    }

    const moveTo = (url, isLogin) => {
        if (isLogin && LoginStates.userId === '') {
            showToast("warning", '로그인 후 이용 가능합니다.');
            return;
        }
        window.open(url, '_blank');        
    }

    const slideStyle = {
        maxWidth: "100%",
        overflow: "hidden"
    }
    const cardStyle = {
        minWidth: "280px"
    }

    return (
        <section className="products">
            <div className="products-wrap">
                <h2 className="section-title">영림원소프트랩 제품</h2>
                <div className="products-slide" style={slideStyle}>
                    <ul className="products-card-wrap" ref={trackRef}>
                        {productList.length > 0 && productList.concat(isOverflow ? productList : []).map((product, index) => {
                            return product.visible !== false && (
                                <Link key={index} onClick={()=>{moveTo(product.url, product.isLogin)}}>
                                    <li className="products-card" style={cardStyle}>
                                        <i className={`products-card-${product.class}`}></i>
                                        <p className="products-card-p">{product.text}</p>
                                        <i className="icoKdc40 arrow"></i>
                                    </li>
                                </Link>
                            )
                        })}
                    </ul>
                </div>
            </div>
        </section >
    );
}

export default Products;